module.exports = __webpack_public_path__ + "img/0S6A0239.f36a1dbb.jpg";